import {
  type FileMetadata,
  type FileMetadataChecks,
  type Procedure,
  Procedures,
} from '@igus/iglidur-free-form-hub-interfaces';

export type BoreholeAndChannelProcedure = typeof Procedures.FDM | typeof Procedures.SLS | typeof Procedures.DLP;

export type BoreholeAndChannelCheck = FileMetadataChecks[BoreholeAndChannelProcedure];

const boreholeAndChannelProcedures: Procedure[] = [Procedures.FDM, Procedures.SLS, Procedures.DLP];

const isBoreholeAndChannelProcedure = (procedure: Procedure): procedure is BoreholeAndChannelProcedure =>
  boreholeAndChannelProcedures.includes(procedure);

export const getBoreholeAndChannelCheck = (
  metadata: FileMetadata | null | undefined,
  procedure: Procedure
): BoreholeAndChannelCheck | null => {
  if (!metadata || !isBoreholeAndChannelProcedure(procedure)) {
    return null;
  }

  return metadata.checks?.[procedure] ?? null;
};
